import { styled } from "@vw-marketing/us-components";

export const StyledAddressVerificationErrorContainer: any = styled.div`
  ${({ theme }) => {
    return `
      border-radius: 8px;
      border: 1px solid ${theme.colors.border.default};
      display: flex;
      gap: ${theme.size.static250};
      padding: ${theme.size.static250};
    `
  }}
`;

export const StyledAlertIconContainer: any = styled.div`
  svg {
    color: ${({ theme }) => theme.colors.signal.error};
  }
`;

export const StyledConfirmationCheckBoxContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static250};
`;